import React from "react";
import {
  Button,
  Tooltip,
  Avatar,
  Typography,
  IconButton,
  CardContent,
  CardActions,
  Grid,
  Card,
  Stack,
} from "@mui/material";
import { FaRegUser } from "react-icons/fa";
import {
  Pause,
  PauseCircle,
  SpeakerHigh,
  SpeakerSimpleX,
} from "@phosphor-icons/react";
import { MdCallEnd } from "react-icons/md";

const SdkCallScreen2 = ({
  call,
  stopwatch2,
  hold_call,
  unhold_call,
  end_call,
}) => {
  return (
    <Card
      className="mb-2"
      sx={{
        boxShadow:
          "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
      }}
    >
      <CardContent className="p-2">
        <Grid container>
          <Grid item md={2}>
            <Avatar
              className="box-inset2 bgs mt-1"
              sx={{
                width: "50px",
                height: "50px",
                fontSize: "16px",
              }}
            >
              <FaRegUser size={22} />
            </Avatar>
          </Grid>
          <Grid item md={10}>
            <Grid
              item
              md={12}
              container
              direction="row"
              justifyContent="flex-start"
              alignContent="center"
            >
              <Grid container direction="row" justifyContent="flex-start">
                <Grid
                  item
                  md={7}
                  className="ps-1"
                  container
                  direction="column"
                  justifyContent="flex-start"
                  alignItems="flex-start"
                  sx={{ minWidth: "0", width: "148px" }}
                >
                  <Typography
                    noWrap
                    variant="h6"
                    className="textp fs-16 fw-bold"
                    sx={{ width: "148px", minWidth: "0" }}
                  >
                    {call.calledDeviceID ? call.calledDeviceID : call.callerId}
                  </Typography>
                </Grid>
                <Grid
                  md={5}
                  item
                  className="text-danger fw-bold"
                  container
                  direction="row"
                  justifyContent="flex-end"
                  alignItems="flex-end"
                  sx={{ minWidth: "0", width: "110px" }}
                >
                  {stopwatch2.hours >= 10
                    ? stopwatch2.hours
                    : "0" + stopwatch2.hours}
                  :
                  {stopwatch2.minutes >= 10
                    ? stopwatch2.minutes
                    : "0" + stopwatch2.minutes}
                  :
                  {stopwatch2.seconds >= 10
                    ? stopwatch2.seconds
                    : "0" + stopwatch2.seconds}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
      <CardActions sx={{ background: "#f6fafe" }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent={"start"}
          sx={{ width: "100%" }}
          spacing={1}
        >
          <Stack
            direction="row"
            alignItems="center"
            justifyContent={"start"}
            sx={{ width: "100%" }}
          >
            {/* {call.Mute && (
              <Tooltip title="Mute" arrow placement="top">
                <IconButton
                  id="Mute_call1"
                  aria-label="Mute"
                  size="small"
                  color="primary"
                  onClick={() => {}}
                >
                  <SpeakerHigh size={18} />
                </IconButton>
              </Tooltip>
            )}
            {!call.Mute && (
              <Tooltip title="UnMute" arrow placement="top">
                <IconButton
                  aria-label="Mute"
                  size="small"
                  color="primary"
                  id="unMute_call1"
                  onClick={() => {}}
                >
                  <SpeakerSimpleX size={18} />
                </IconButton>
              </Tooltip>
            )} */}
            {call.Hold && (
              <Tooltip title="hold" arrow placement="top">
                <IconButton
                  aria-label="Hold"
                  size="small"
                  color="primary"
                  id="call"
                  onClick={() => {
                    hold_call(call.contactId, "agentCall");
                  }}
                >
                  <Pause size={18} />
                </IconButton>
              </Tooltip>
            )}
            {!call.Hold && (
              <Tooltip title="Unhold" arrow placement="top">
                <IconButton
                  aria-label="Hold"
                  size="small"
                  color="secondery"
                  id="call"
                  onClick={() => {
                    unhold_call(call.contactId, "agentCall");
                  }}
                >
                  <PauseCircle size={18} />
                </IconButton>
              </Tooltip>
            )}
          </Stack>

          {call.Hold && (
            <Button
              size="small"
              color="primary"
              className="call-btn bg-danger fs-20 ms-2"
              sx={{ borderRadius: "4px", color: "white" }}
              id="call"
              onClick={() => {
                end_call(call.contactId);
              }}
            >
              <MdCallEnd />
            </Button>
          )}
        </Stack>
      </CardActions>
    </Card>
  );
};

export default SdkCallScreen2;
